<div class="item-container pt-0">
    <div class="edit-icons" (click)="onCancel()" mat-dialog-close>
        <i class="material-icons">close</i>
    </div>
    <div class="content">
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/icons/are_you_sure.png" class="img-fluid" alt="">
        </div>
        <h5 class="text-center item-txt mt-3" *ngIf="dialogData.type!='clear'&& dialogData.type!='copy'">Are you sure you want to change {{dialogData?.text}}?</h5>
        <div *ngIf="dialogData.type=='clear'||dialogData.type=='copy'">
            <h5 class="text-center item-txt mt-3">{{dataObj?.title}}</h5>
            <div class="item-small mt-3 text-center">{{dataObj?.subTitle}}</div>
        </div>
    </div>
    <div class="shift-content" *ngIf="dialogData.type=='clear'||dialogData.type=='copy'">
        Total shifts to be {{dataObj?.type}} : <span class="text-semibold">{{totalShift}}</span>
    </div>
    <div class="btn-container d-flex mt-4">
        <button color="" class="auth-form-btn outline-btn new-outline d-flex align-items-center justify-content-center"
            (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="warn" class="auth-form-btn  success-btn ms-3" type="submit"
            (click)="onConfirm()">Yes</button>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>